/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Icy_Small_Osprey_JestInputs */

const fr_icy_small_osprey_jest = /** @type {(inputs: Icy_Small_Osprey_JestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un produit avec Tarif`)
};

/**

* @param {Icy_Small_Osprey_JestInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const icy_small_osprey_jest = /** @type {((inputs?: Icy_Small_Osprey_JestInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Icy_Small_Osprey_JestInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_icy_small_osprey_jest(inputs)
});